import { queryOptions, useQuery } from '@tanstack/react-query';

import { getPackageWithGroups } from '../actions/getPackage';
import { PackageWithGroupsResponse } from '../api/types';

export const getPackageWithGroupsQueryKey = (packageId: string) => [
  'package',
  packageId,
  'groups',
];

export const getPackageWithGroupsQueryOptions = (packageId: string) =>
  queryOptions({
    queryKey: getPackageWithGroupsQueryKey(packageId),
    queryFn: async () => {
      const response = await getPackageWithGroups({
        data: { packageId },
      });

      if (!response.success || response.error) {
        throw new Error(response.error || 'Unknown error');
      }

      return response.data as PackageWithGroupsResponse;
    },
  });

export const useGetPackageWithGroups = (documentId: string) =>
  useQuery(getPackageWithGroupsQueryOptions(documentId));
